// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2waPO","label":"styles_label__3aUV_"};